export default __webpack_public_path__ + "static/media/You_Preview.11dbbae6.mp4";